export const IconsStatus: IIconsStatus[] = [
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/la_user-tie.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/la_user-tag.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/la_user-shield.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/la_user-nurse.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/la_user-lock.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/ci_user.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/ci_user-close.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/ci_user-check.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/carbon_user-certification.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/carbon_user-activity.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/carbon_pending.svg',
	},
	{
		name: '',
		url: 'https://cdn.mango-soft.com/access-control/carbon_open.svg',
	},
];

export interface IIconsStatus {
	name: string;
	url: string;
}
